import GoogleMapBaseStyle from './GoogleMapBaseStyle';

const GoogleMapHybridStyle = [
  ...GoogleMapBaseStyle,
  {
    featureType: 'poi',
    stylers: [ {
      visibility: 'off',
    } ],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [ {
      visibility: 'off',
    } ],
  },
];

export default GoogleMapHybridStyle;
